import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStoreDetails } from './common/Providers/StoreDetailsProvider/UseStoreDetails';
import { getBackupData } from './api/Product';
import { useCustomerReservation } from './common/Providers/CustomerReservationProvider/UseCustomerReservation';
import { testTokenVaild } from './api/Auth';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { storeDetails } = useStoreDetails();
  const location = useLocation();
  const { setReservationValue, addReservationItems, initReservation } = useCustomerReservation();

  useEffect(() => {
    
    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get('mode');
    const id = queryParams.get('id');

    initReservation();
    
    if(mode == 'backup'){
      const payload = { id: id }
      getBackupData(payload, (jsonRes:any)=>{
        if(!jsonRes.start_date) {
          navigate('/reservation');
          return;
        }
        setReservationValue('pickup', new Date(jsonRes.start_date))
        setReservationValue('dropoff',new Date(jsonRes.end_date))
        setReservationValue('price_table_id', jsonRes.price_table_id)
        if(jsonRes.note) setReservationValue('note', jsonRes.note)
        if(jsonRes.address_id) setReservationValue('address_id', jsonRes.address_id)
        if(jsonRes.use_manual) setReservationValue('use_manual', jsonRes.use_manual)
        if(jsonRes.manual_address) setReservationValue('manual_address', jsonRes.manual_address)
        if(jsonRes.driver_tip) setReservationValue('driver_tip', jsonRes.driver_tip)
        if(jsonRes.promo_code) setReservationValue('discount_code', jsonRes.promo_code)
        if(jsonRes.email) setReservationValue('email', jsonRes.email)
        if(jsonRes.phone_number) setReservationValue('phone_number', jsonRes.phone_number)
        if(jsonRes.all_addresses) setReservationValue('selectedAddress', jsonRes.all_addresses)
        // if(jsonRes.all_addresses) setReservationValue('selectedAddress', {
        //   number:jsonRes.all_addresses.number,
        //   street:jsonRes.all_addresses.street,
        //   property_name:jsonRes.all_addresses.property_name,
        //   plantation:jsonRes.all_addresses.plantation,
        // })
        setReservationValue('prices', {
          subtotal: jsonRes.subtotal,
          tax: jsonRes.tax_amount,
          discount: jsonRes.discount_amount,
          total: jsonRes.total_price})

        addReservationItems(jsonRes.items)
        localStorage.setItem('preId', jsonRes.id);
        if(storeDetails.process_mode){
          navigate('/review');
        } else {
          const accessToken = localStorage.getItem('access-token');
          if(accessToken){
            testTokenVaild((jsonRes:any, status:any)=>{
              if(status == 200) navigate('/review');
            });
          }else{
            localStorage.setItem('__restore', '1');
            navigate('/login')
          }
        }
      });
    }else if(storeDetails.process_mode){
      navigate('/reservation');
    } else navigate('/login');

  }, [navigate]);

  return (
    <div>
    </div>
  );
};

export default Home;